import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
import { ContactForm } from './ContactForm';
export function CTA() {
  return <Section id="contact" className="bg-[#0B1426] relative overflow-hidden border-y border-white/5" data-id="element-76">
      {/* Background decoration */}
      <div className="absolute inset-0" data-id="element-77">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#d8a43e]/10 rounded-full blur-[120px] animate-pulse" data-id="element-78" />
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-blue-900/20 rounded-full blur-[120px]" data-id="element-79" />
        <div className="absolute inset-0 bg-grid-pattern opacity-[0.05]" data-id="element-80" />
      </div>

      <div className="relative z-10 text-center max-w-4xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-block mb-6" data-id="element-82">
          <div className="px-4 py-1 rounded-full border border-[#d8a43e]/30 bg-[#d8a43e]/5 backdrop-blur-sm" data-id="element-83">
            <span className="text-[#d8a43e] font-mono text-xs tracking-widest uppercase" data-id="element-84">
              Start Your Journey
            </span>
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight" data-id="element-85">
          Ready to Transform Your <br data-id="element-86" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d8a43e] to-[#f3d288] text-glow" data-id="element-87">
            Digital Presence?
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-88">
          Let's discuss how we can help you achieve your business goals with our
          expert design and development services.
        </motion.p>

        {/* Contact Form Integration */}
        <ContactForm data-id="element-89" />
      </div>
    </Section>;
}